module.exports = __webpack_public_path__ + "img/icon-white-h2h.c8f6dba6.svg";